import Axios from 'axios';
import Lodash from 'lodash';
import * as Antd from 'antd';
import * as Hash from 'object-hash';
import * as SYS from '../system';
import { datasetgridColumnsStorage, getCacheItem, setCacheItem } from '../../storage';

const listToTreeByParentId = (list) => {
    var map = {}, node, roots = [], i;

    for (i = 0; i < list.length; i += 1) {
        map[list[i].id] = i;
        list[i].children = [];
    }

    for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parentId !== null) {
            list[map[node.parentId]].children.push(node);
        } else {
            roots.push(node);
        }
    }
    return roots;
}

// export const fetchData = async (connector, dataset, filters = {}, fetch = null, method = null, auth = null) => {    
export const fetchData = async (props = {}, auth = null, forced = false, expiration = null) => {
    try {
        if (!props.connector) {
            throw new Error('Missing required parameter `connector`!');
        }
        if (!props.dataset) {
            throw new Error('Missing required parameter `dataset`!');
        }

        let responseData = null;
        let returnData = null;

        let filters = props.filters ? props.filters : {};
        let filtersHash = Hash.MD5(filters);

        let cacheItem = await getCacheItem(`${props.connector}-${props.dataset}-${filtersHash}`);
        if (!cacheItem.data || cacheItem.isExpired || forced) {
            let { data } = await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/${props.method || 'find'}/${props.connector}/${props.dataset}`, filters, {
                headers: {
                    Authorization: `Bearer ${auth.accessToken}`
                }
            });
            responseData = data;
            if (expiration !== null) {
                await setCacheItem(`${props.connector}-${props.dataset}-${filtersHash}`, responseData, cacheItem.expiration && expiration === 0 ? cacheItem.expiration : expiration);
            }
        } else {
            responseData = cacheItem.data;
        }

        switch (props.fetch) {
            case 'tree':
                returnData = listToTreeByParentId(responseData);
                break;
            case 'one':
                returnData = responseData[0];
                break;
            default:
                returnData = responseData;
                break;
        }

        return returnData;
    } catch (err) {
        console.log({
            parameters: {
                connector: props.connector,
                dataset: props.dataset,
                filters: props.filters,
                method: props.method,
                fetch: props.fetch,
                auth: auth,
            },
            error: err
        });
        Antd.message.error('Data could not be loaded, please try again later!');
        return null;
    }
};

export const actionCall = async (props, auth) => {
    try {
        if (!props.action) {
            throw new Error('Missing required parameter `action`!');
        }
        if (!props.payload) {
            throw new Error('Missing required parameter `payload`!');
        }

        let response = await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/action/${props.action}`, props.payload, {
            headers: {
                Authorization: `Bearer ${auth.accessToken}`
            }
        });
        return response.data;
    } catch (err) {
        console.log({
            parameters: {
                action: props.action,
                payload: props.payload,
                auth: auth,
            },
            error: err
        });
        Antd.message.error('Action call failed, please try again later!');
        return null;
    }
};

export const fetchData1 = async (connector, dataset, filters = {}, fetch = null, method = null, auth = null) => {
    try {
        if (!connector) {
            throw new Error('Missing required parameter `connector`!');
        }
        if (!dataset) {
            throw new Error('Missing required parameter `dataset`!');
        }
        let response = await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/${method || 'find'}/${connector}/${dataset}`, filters ? filters : {}, {
            headers: {
                Authorization: `Bearer ${auth.accessToken}`
            }
        });

        let data = null;
        switch (fetch) {
            case 'tree':
                data = listToTreeByParentId(response.data);
                break;
            case 'one':
                data = response.data[0];
                break;
            default:
                data = response.data;
                break;
        }
        return data;
    } catch (err) {
        console.log({
            parameters: {
                connector: connector,
                dataset: dataset,
                filters: filters,
                method: method,
                auth: auth,
            },
            error: err
        });
        Antd.message.error('Data could not be loaded, please try again later!');
        return null;
    }
};

export const fetchColumns = async (props = {}, auth = null, forced = false) => {
    try {
        if (!props.connector) {
            throw new Error('Missing required parameter `connector`!');
        }

        if (!props.dataset) {
            throw new Error('Missing required parameter `dataset`!');
        }

        let storageKey = `${props.connector}_${props.dataset}_${props.name ? props.name : 'default'}`;
        let storedColumns = await datasetgridColumnsStorage.getItem(storageKey);

        let columns = [];

        if (!storedColumns || forced) {
            let response = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/datasets`, {
                headers: {
                    Authorization: `Bearer ${auth.accessToken}`
                },
                params: {
                    filter: {
                        where: {
                            code: props.dataset
                        }
                    }
                }
            });

            columns = response.data[0].columns;

            // Filter only server side enabled columns ( and client side - props)        
            // columns = Lodash.filter(props.columns, (o) => (o.settings.datagrid.enable));


            // Filter only client side (props) enabled columns
            // if (props.columns && props.columns.length > 0) {
            //     columns = Lodash.filter(columns, (o) => {
            //         if (props.columns.indexOf(o.fieldName) > 0) {
            //             return o;
            //         }
            //     });
            // }

            await datasetgridColumnsStorage.setItem(storageKey, columns);
        } else {
            columns = storedColumns;
        }

        // Filter only server side enabled columns ( and client side - props)        
        let eColumns = [];
        for (let col of columns) {
            if (col.settings.datagrid.enable) {
                eColumns.push(col);
            }
        }
        columns = eColumns;

        // Filter only client side (props) enabled columns
        if (props.columns && props.columns.length > 0) {
            let cColumns = [];
            for (let col of columns) {
                if (props.columns.indexOf(col.fieldName) > 0) {
                    cColumns.push(col);
                }
            }
            columns = cColumns;
        }

        return columns;
    } catch (err) {
        console.log({
            parameters: {
                connector: props.connector,
                dataset: props.dataset,
                auth: auth,
            },
            error: err
        });
        Antd.message.error('Datagrid columns could not be loaded, please try again later!');
        return null;
    }
};

export const setStorage = async (key, data, auth = null) => {
    try {
        if (!key) {
            throw new Error('Missing required parameter `key`!');
        }
        if (!data) {
            throw new Error('Missing required parameter `data`!');
        }

        let requestBody = {
            data: SYS.toBinaryV2(data)
        }

        await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/storage/${key}`, requestBody, {
            headers: {
                Authorization: `Bearer ${auth.accessToken}`
            }
        });

        return true;
    } catch (err) {
        console.log({
            parameters: {
                key: key,
                auth: auth,
            },
            error: err
        });
        return null;
    }
};

export const getStorage = async (key, auth = null) => {
    try {
        if (!key) {
            throw new Error('Missing required parameter `key`!');
        }

        let { data } = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/storage/${key}`, {
            headers: {
                Authorization: `Bearer ${auth.accessToken}`
            }
        });

        return SYS.fromBinaryV2(data.data)
    } catch (err) {
        console.log({
            parameters: {
                key: key,
                auth: auth,
            },
            error: err
        });
        return null;
    }
};